<template>
  <div>
    <a-spin :spinning="loading">
      <a-row :gutter="16" class="text-center">
        <a-col :span="24" class="text-left">
          <h5 class="mb-1"></h5>
          <a-form layout="inline">
            <a-form-item :help="_trs('Delivery date')">
              <a-date-picker
                v-model="date"
                :placeholder="_trs('Select date')"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
            <a-form-item>
              <a-button class="btn btn-success" @click="search">{{
                _trs('Get results')
              }}</a-button>
            </a-form-item>
          </a-form>

          <h5 class="font-weight-light mb-3" style="margin-top: 70px;">
            {{ _trs('Blocks per day') }}
          </h5>
        </a-col>
        <a-col :span="24">
          <div class="table-scroll-wrapper">
            <table class="border">
              <th
                class="border-right text-center v-mid border-bottom"
                rowspan="2"
              >
                {{ _trs('Block name') }}
              </th>
              <th
                colspan="2"
                v-for="date in availableDatesForBlocks"
                :key="date"
                class="text-center text-danger border-right-table-cell border-bottom"
              >
                {{ date }}
              </th>
              <tr>
                <!-- <td class="border-right"></td> -->
                <td
                  v-for="i in availableDatesForBlocks.length * 2"
                  :key="i"
                  class="text-bold text-center border-right-table-cell border-bottom"
                >
                  {{
                    i % 2 == 0 ? _trs('Cijena [€/MWh]') : _trs('Volume [MWh]')
                  }}
                </td>
              </tr>
              <tr v-for="(row, index) in perBlockData" :key="index">
                <td class="border-right text-center">
                  {{ blockNames[index] }}
                </td>
                <td
                  v-for="(cell, idx) in row"
                  :key="index + idx.toString()"
                  class="text-center border-right-table-cell"
                >
                  {{ cell }}
                </td>
              </tr>
            </table>
          </div>

          <h5
            class="font-weight-light mb-3 text-left"
            style="margin-top: 70px;"
          >
            {{ _trs('Hourly data') }}
          </h5>

          <div class="table-scroll-wrapper">
            <table class="border">
              <th
                class="border-right text-center v-mid border-bottom"
                rowspan="2"
              >
                {{ _trs('Hour') }}
              </th>
              <th
                colspan="2"
                v-for="date in availableDatesDayAhead"
                :key="date"
                class="text-danger text-center border-right-table-cell border-bottom"
              >
                {{ date }}
              </th>
              <tr>
                <!-- <td class="border-right"></td> -->
                <td
                  v-for="i in availableDatesDayAhead.length * 2"
                  :key="i"
                  class="text-center text-bold border-bottom border-right-table-cell"
                >
                  {{
                    i % 2 == 0 ? _trs('Cijena [€/MWh]') : _trs('Volume [MWh]')
                  }}
                </td>
              </tr>
              <tr v-for="(row, index) in hourlyData" :key="index">
                <td class="text-right border-right">{{ index + 1 }}</td>
                <td
                  v-for="(cell, idx) in row"
                  :key="index + idx.toString()"
                  class="border-right-table-cell text-center"
                >
                  {{ cell }}
                </td>
              </tr>
            </table>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>
<script>
import { XmlService } from '@/services/api'

// import { Chart } from '@antv/g2'
import { Modal } from 'ant-design-vue'
import moment from 'moment'
import { _trs } from '../../../../utilities'

export default {
  name: 'Tables',
  components: {},

  data: function () {
    return {
      loading: false,
      week: [],
      blockNames: ['01-24 (Baseload)', '09-20 (Peakload)'],
      availableDatesForBlocks: [],
      perBlockData: [],
      hourlyData: [],
      // availableBlocks: [],
      availableDates: null,
      marketResultBlocks: null,
      dayAheadResults: null,
      availableTimeSteps: [],
      availableDatesDayAhead: [],
      days: null,
      chartPrice: null,
      chartQty: null,
      dateFormat: 'YYYY-MM-DD',
      date: moment().add(1, 'day'),
    }
  },
  methods: {
    _trs,
    isDateTooOld(date) {
      if (!date) return false
      const twoWeeksAgo = moment().subtract(14, 'days').startOf('day')
      return moment(date).isBefore(twoWeeksAgo)
    },
    showDateRestrictionModal() {
      Modal.warning({
        title: _trs('Data Not Available'),
        content: _trs('Data older than 2 weeks is available upon request according to the commercial terms. Contact dam@belen-spot.me for more info.'),
      })
    },
    search() {
      if (this.date == null || this.date == '') {
        Modal.warning({
          title: _trs('Date is not set'),
          content: _trs('Please choose the date to fetch the data'),
        })
        return false
      }
      if (this.isDateTooOld(this.date)) {
        this.loading = false
        this.showDateRestrictionModal()
        return false
      }
      this.getData()
    },
    toDecimal(value, radix) {
      return value.toLocaleString('de-DE', {
        maximumFractionDigits: radix,
        minimumFractionDigits: radix,
      })
    },
    fillPerBlockData() {
      for (const blockName of this.blockNames) {
        const rowData = []

        for (const day of this.availableDatesForBlocks) {
          const blockForDay = this.marketResultBlocks.find(
            (x) => x.delivery_day == day && x.block_name == blockName
          )

          console.log('Block', blockForDay)

          if (blockForDay) {
            rowData.push(this.toDecimal(blockForDay.block_volume, 1))
            rowData.push(this.toDecimal(blockForDay.block_price, 2))
          } else {
            rowData.push('')
            rowData.push('')
          }
        }

        this.perBlockData.push(rowData)
      }
    },
    fillHourlyData() {
      this.hourlyData = []
      for (const timeStep of this.availableTimeSteps) {
        var rowData = []
        const dayAhead = this.dayAheadResults.filter(
          (x) => x.time_step_id == timeStep
        )

        for (const day of this.availableDatesDayAhead) {
          const hourData = dayAhead.find(
            (hourlyData) => hourlyData.delivery_day == day
          )
          if (hourData) {
            rowData.push(this.toDecimal(hourData.index_volume, 1))
            rowData.push(this.toDecimal(hourData.index_price, 2))
          } else {
            rowData.push('-')
            rowData.push('-')
          }
        }
        this.hourlyData.push(rowData)
      }
    },
    async getData() {
      this.week = []
      this.hourlyData = []
      this.perBlockData = []
      this.loading = true
      const blocksResponse = await XmlService.getMarketResultBlockForTable({
        date: moment(this.date).format('YYYY-MM-DD'),
      })

      // blocks data
      this.marketResultBlocks = blocksResponse.data.data
      // this.availableBlocks = weeklyResponse.data.availableBlocks
      this.availableDatesForBlocks = blocksResponse.data.availableDates

      //hourly table
      const dayAheadResponse = await XmlService.getDayAheadResultTable({
        date: moment(this.date).format('YYYY-MM-DD'),
      })

      this.loading = false

      // day ahead - hourly data
      this.dayAheadResults = dayAheadResponse.data.data
      this.availableTimeSteps = dayAheadResponse.data.availableTimeSteps
      this.availableDatesDayAhead = dayAheadResponse.data.availableDates

      this.fillPerBlockData()
      this.fillHourlyData()
    },
  },
  mounted() {
    this.search()
  },
}
</script>
<style>
.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

td {
  padding: 0px 20px;
  text-align: right;
}

.header-row {
  font-weight: bold;
}

tr {
  height: 27px;
}

.blank-row {
  height: 27px;
  background-color: #ffffff;
}

table {
  margin-left: auto;
  margin-right: auto;
}

.text-bold {
  font-weight: 600;
}

.v-mid {
  vertical-align: middle;
}

.border-right-table-cell:not(:last-child) {
  border-right: 1px solid #ccc;
}
</style>
